import React,{Component} from 'react';
import { firebaseAuth,ref } from '../config/constants'



import Sidebar from './inc/Sidebar';
import Header from './inc/Header';
import Title from './inc/Title';
import Footer from './inc/Footer';
import ReturnProduct from './ReturnProduct'
import ReturnSheet from './ReturnSheet'
import Modal from './Modal'
import InventoryDisplayProduct from './InventoryDisplayProduct'
import InventoryDisplaySheet from './InventoryDisplaySheet'

class Inventory extends Component{

	constructor(){
        super();
        this.state = {
            user : {},
            inventoryListProduct : {},
            inventoryListSheet :{}
        }
    }
    
    componentWillMount() {

        this.listener = firebaseAuth().onAuthStateChanged(user=>{
            if (user){
                var db = ref.child("users").child(user.uid);
                    db.on("value",function(data){
                      
                        this.setState({
                            userId:data.key,
                            user:data.val()
                        });

                    }.bind(this));
            }else{
                this.props.history.push("/login");
            }

        });
        
            
    } 
    componentDidMount(){
        var listProduct = ref.child("Inventory").child("Products")
            listProduct.on("value", function(snap){
                this.setState({
                    inventoryListProduct : snap.val()
                })
            }.bind(this))

        var listSheet = ref.child("Inventory").child("Sheets")
            listSheet.on("value", function(snap){
                this.setState({
                    inventoryListSheet : snap.val()
                })
            }.bind(this))
    }
    

    render() {
      
        return (
            <div id="page-wrapper">
                <Modal id="ReturnProduct" title="Return Products">
                    <ReturnProduct/>
                </Modal>
                <Modal id="ReturnSheet" title="Return Sheet">
                    <ReturnSheet/>
                </Modal>
                <div id="page-container" className="sidebar-partial sidebar-visible-lg sidebar-no-animations">
                    <Sidebar  role={this.state.user.role} />
                    <div id="main-container">
                        <Header />
                        <div id="page-content">
                            <Title title="Inventory" />
                            <div className="row text-center">
                                <div className="col-sm-6 col-lg-3">
                                    <a href="products/new" className="widget widget-hover-effect2">
                                        <div className="widget-extra themed-background-success">
                                            <h4 className="widget-content-light"><strong>Add New</strong> Product</h4>
                                        </div>
                                        <div className="widget-extra-full"><span className="h2 text-success animation-expandOpen"><i className="fa fa-plus"></i></span></div>
                                    </a>
                                </div>                                
                            </div>
                            <div className="block">
                                <div className="block full">
                                    <div className="block-title">
                                      <h2><strong>All</strong> Products</h2>
                                    </div>
                                    <button className="btn btn-primary marginLeft3px marginBot5px" data-toggle="modal" data-target="#ReturnProduct"><i className="fa fa-undo" aria-hidden="true"></i> Return Product</button>                                        
                                    <div className="table-responsive">
                                        <table id="ecom-products" className="table table-bordered table-striped table-vcenter">
                                            <thead>
                                                <tr>               
                                                    <th className="text-center">Product Name</th>
                                                    <th className="text-center">Unit</th>
                                                    <th className="text-center">Length</th>
                                                    <th className="text-center">Color</th>
                                                    <th className="text-center">Count</th>
                                                    <th className="text-center">Action</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {
                                                    Object.keys(this.state.inventoryListProduct).map(key => {
                                                        let list = this.state.inventoryListProduct[key]
                                                        if(list.product_count !== 0){
                                                            return <InventoryDisplayProduct key={key} product={list} index={key}/>
                                                        }
                                                    })
                                                }
                                            </tbody>
                                        </table>
                                    </div>    
                                    <div className="block-title">
                                      <h2><strong>All</strong> Plain Sheets</h2>
                                    </div>
                                    <button className="btn btn-primary marginLeft3px marginBot5px" data-toggle="modal" data-target="#ReturnSheet"><i className="fa fa-undo" aria-hidden="true"></i> Return Sheet</button>                                        
                                    <div className="table-responsive">
                                        <table id="ecom-products" className="table table-bordered table-striped table-vcenter">
                                            <thead>
                                                <tr>               
                                                    <th className="text-center">Item</th>
                                                    <th className="text-center">Unit</th>
                                                    <th className="text-center">Thickness</th>
                                                    <th className="text-center">Dimension</th>
                                                    <th className="text-center">Length</th>
                                                    <th className="text-center">Color</th>
                                                    <th className="text-center">Count</th>
                                                    <th className="text-center">Action</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {
                                                    Object.keys(this.state.inventoryListSheet).map(key => {
                                                        let list = this.state.inventoryListSheet[key]
                                                        if(list.count!==0){
                                                            return <InventoryDisplaySheet key={key} sheet={list} index={key}/>
                                                        }
                                                    })
                                                }
                                                
                                            </tbody>
                                        </table>
                                    </div>    
                                </div>    
                            </div>
                        </div>
                        <Footer />
                    </div>
                </div>
            </div>
      
        );
    }
}

export default  Inventory;



// WEBPACK FOOTER //
// ./src/components/Inventory.js